import React from 'react'
import Slider from "react-slick";

function Testimonial() {

     let settings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
      };

  return (
    <>
       <section className="testimonial-area pt-20 pb-20 p-relative fix">
            <div className="animations-01">
                <img src="/assets/img/bg/an-img-03.png" alt="an-img-01" />
            </div>
            <div className="animations-02">
                <img src="/assets/img/bg/an-img-04.png" alt="contact-bg-an-01" />
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title text-center mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                            <h5>
                                <i className="fal fa-graduation-cap" /> Testimonial
                            </h5>
                            
                            <h2>What Our Students Say</h2>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <Slider className="testimonial-active wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s" {...settings}>

                            <div className="single-testimonial text-center">
                                <div className="qt-img">
                                    <img src="/assets/img/testimonial/qt-icon.png" alt="img" />
                                </div>
                                <p>
                                    Studying at Akash Institute of Pharmacy has been a life-changing experience. The faculty are incredibly supportive and the laboratory facilities helped me build real confidence in pharmaceutical sciences.
                                </p>
                                <div className="testi-author">
                                    <img src="/assets/img/testimonial/testi_avatar.png" alt="img" />
                                </div>
                                <div className="ta-info">
                                <h6>Priya Sharma</h6>
                                <span>B.Pharm Student, 3rd Year</span>
                                </div>
                            </div>

                            <div className="single-testimonial text-center">
                                <div className="qt-img">
                                    <img src="/assets/img/testimonial/qt-icon.png" alt="img" />
                                </div>
                                <p>
                                    The practical training at AIP is exceptional. From day one, we were given hands-on exposure in well-equipped labs. The RGUHS-aligned curriculum truly prepared me for the competitive pharma industry.
                                </p>
                                <div className="testi-author">
                                    <img src="/assets/img/testimonial/testi_avatar_02.png" alt="img" />
                                </div>
                                <div className="ta-info">
                                <h6>Rahul Nair</h6>
                                <span>B.Pharm Graduate, 2024</span>
                                </div>
                            </div>

                            <div className="single-testimonial text-center">
                                <div className="qt-img">
                                    <img src="/assets/img/testimonial/qt-icon.png" alt="img" />
                                </div>
                                <p>
                                    AIP's dedicated faculty and industry-oriented approach gave me the skills and confidence to build a successful career in the pharmaceutical field. I'm proud to be an alumnus of this institution.
                                </p>
                                <div className="testi-author">
                                    <img src="/assets/img/testimonial/testi_avatar_03.png" alt="img" />
                                </div>
                                <div className="ta-info">
                                    <h6>Sneha Reddy</h6>
                                    <span>Pharma Professional</span>
                                </div>
                            </div>

                            <div className="single-testimonial text-center">
                                <div className="qt-img">
                                    <img src="/assets/img/testimonial/qt-icon.png" alt="img" />
                                </div>
                                <p>
                                    What I love most about AIP is the balance between academics and personal development. The seminars, workshops, and mentorship sessions helped me grow both professionally and as an individual.
                                </p>
                                <div className="testi-author">
                                    <img src="/assets/img/testimonial/testi_avatar.png" alt="img" />
                                </div>
                                <div className="ta-info">
                                <h6>Arjun Menon</h6>
                                <span>B.Pharm Student, 2nd Year</span>
                                </div>
                            </div>
                            
                            <div className="single-testimonial text-center">
                                <div className="qt-img">
                                    <img src="/assets/img/testimonial/qt-icon.png" alt="img" />
                                </div>
                                <p>
                                    Choosing AIP was one of the best decisions of my life. The institute's focus on ethics, research, and real-world practice has shaped me into a well-rounded pharmacy professional.
                                </p>
                                <div className="testi-author">
                                    <img src="/assets/img/testimonial/testi_avatar_02.png" alt="img" />
                                </div>
                                <div className="ta-info">
                                <h6>Kavya Krishnan</h6>
                                <span>Clinical Research Associate</span>
                                </div>
                            </div>

                        </Slider>
                    </div>
                </div>
            </div>
       </section>
    </>
  )
}

export default Testimonial